import type { GiantId } from '../ids/ids';
import type { MissionRef } from './mission';

/**
 * Фактический номер PNG (1…33) для каждого заказа.
 *
 * Файлы в `delivery_items/` лежат не в порядке {@link GIANT_ORDERS} /
 * прежнего flat-index — явная таблица выровнена по содержимому арта.
 *
 * `factor` order 2 («Чайник»): отдельного арта нет, временно 7.png
 * (дубликат котлеты). Нужен отдельный ассет чайника.
 */
export const DELIVERY_ITEM_ASSET_INDEX: Record<
  GiantId,
  readonly [number, number, number]
> = {
  svami: [1, 2, 3],
  roza: [22, 23, 24],
  drakochi: [31, 32, 33],
  yetti: [28, 29, 30],
  mona: [16, 17, 18],
  duck: [13, 14, 15],
  serj: [25, 20, 8],
  factor: [9, 19, 7],
  willy: [21, 4, 5],
  sol: [6, 26, 27],
  mu: [10, 11, 12],
};

/** @deprecated Порядок файлов больше не flat — см. {@link DELIVERY_ITEM_ASSET_INDEX}. */
export const DELIVERY_ITEM_ASSET_GIANT_ORDER = [
  'svami',
  'roza',
  'drakochi',
  'yetti',
  'mona',
  'duck',
  'serj',
  'factor',
  'willy',
  'sol',
  'mu',
] as const satisfies readonly GiantId[];

export const DELIVERY_ITEM_ASSET_COUNT = 33;

/** Индекс png-ассета (1…33) или null, если для заказа ещё нет арта. */
export function getDeliveryItemAssetIndex(mission: MissionRef): number | null {
  const byGiant = DELIVERY_ITEM_ASSET_INDEX[mission.giantId];
  if (byGiant == null) {
    return null;
  }
  const assetIndex = byGiant[mission.orderIndex];
  if (assetIndex == null) {
    return null;
  }
  if (assetIndex < 1 || assetIndex > DELIVERY_ITEM_ASSET_COUNT) {
    return null;
  }
  return assetIndex;
}
